import reviewsSummaryStore from 'store/reviews-summary-store'

export function schemaOrgEntityType(schemaOrgEntityType: string): void {
  if (schemaOrgEntityType) {
    reviewsSummaryStore.schemaOrgEntityType = schemaOrgEntityType
  }
}
